import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import CloseOutlined from '@material-ui/icons/CloseOutlined'

type ModalProps = {
  children: React.ReactNode
  title?: React.ReactNode
  subTitle?: string
  open: boolean
  onClose(): void
  preventBackdropDismiss?: boolean
  maxWidth?: 'sm' | 'xs' | 'md' | 'lg' | 'xl'
  testId?: string
}

export const Modal: React.FC<ModalProps> = ({
  open,
  onClose,
  title = '',
  subTitle,
  preventBackdropDismiss = true,
  maxWidth,
  children,
  testId = 'modal',
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth ?? 'sm'}
      open={open}
      onClose={(event, reason) => {
        if (preventBackdropDismiss && reason !== 'backdropClick' && reason !== 'escapeKeyDown') onClose()
      }}
      aria-labelledby="form-dialog-title"
      data-testid={testId}
    >
      <DialogContent className="p-6">
        <div className="flex justify-between">
          <div className="w-full text-2xl" id="form-dialog-title">
            {title}
          </div>
          <CloseOutlined className="cursor-pointer" onClick={onClose} data-testid={'mui-closeoutlined-icon-button'} />
        </div>
        {subTitle && <div className="text-lg font-light">{subTitle}</div>}
        <div className="px-1 mt-5">{children}</div>
      </DialogContent>
    </Dialog>
  )
}
